import React, { useMemo } from "react";
import "../../assets/assets/fonts/QuillFonts.css";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Quill from "quill";

const Font = Quill.import("formats/font");
Font.whitelist = [
  "sans-serif",
  "serif",
  "monospace",
  "jameel-noori-nastaleeq",
  "al-qalam-quran-majeed-web",
  "mb-lateefi",
  "amiri-arabic",
  "muhammadi-quranic",
];
Quill.register(Font, true);

const Inline = Quill.import("blots/inline");
const icons = Quill.import("ui/icons");
icons["overline"] = `
  <svg viewBox="0 0 18 18">
    <line x1="3" y1="4" x2="15" y2="4" stroke="currentColor" stroke-width="2"/>
    <line x1="6" y1="14" x2="12" y2="14" stroke="currentColor" stroke-width="2"/>
  </svg>
`;

class OverlineBlot extends Inline {
  static create() {
    const node = super.create();
    node.style.textDecoration = "overline";
    return node;
  }

  static formats() {
    return true;
  }
}

OverlineBlot.blotName = "overline";
OverlineBlot.tagName = "SPAN";

Quill.register(OverlineBlot);

const modulesConfig = {
  toolbar: [
    [{ font: Font.whitelist }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "overline"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ direction: "rtl" }],
    ["blockquote", "code-block"],
    [{ align: [] }],
    ["link"],
  ],
  clipboard: {
    matchVisual: false,
  },
};

const formats = [
  "font",
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "script",
  "indent",
  "direction",
  "blockquote",
  "code-block",
  "align",
  "link",
  "overline",
];

export default function QuilTextEditor({
  placeholder = "Write",
  onChange = () => {},
  value = "",
  editorRef,
}) {
  const modules = useMemo(() => modulesConfig, []);

  return (
    <ReactQuill
      value={value}
      onChange={(e) => onChange(e)}
      placeholder={placeholder}
      modules={modules}
      formats={formats}
      preserveWhitespace={true}
      className="react-quill"
      ref={editorRef}
    />
  );
}



